import { GET_CONSTRUCTION_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_CONSTRUCTION_TYPES_SUCCESS: {
      const constructionTypes = action.payload;

      if (!constructionTypes){
        return [...state];
      }

      return [
        ...state,
        ...constructionTypes
      ]
    }
    default:
      return state;
  }
}
